import { createContext, useContext, type ReactNode } from 'react';

/**
 * What the frame puts into every page header on a phone (S150-8): there is no top bar below
 * 1024 px, so the credit balance, the search and the bell sit in the header's top row instead.
 * `null` from 1024 px, where the top bar carries them.
 */
export const PageToolsContext = createContext<ReactNode>(null);

export const usePageTools = (): ReactNode => useContext(PageToolsContext);
